
import { Injectable } from '@angular/core';



// @Injectable()
@Injectable({
  providedIn: 'root'
})
export class RequestModelService {

  constructor() {
  }

  getStaticRequestDataTemp() {
    return {
      'PWSESSIONRS': {
        'PWPROCESSRS': {
          'PWHEADER': {
            'IN_PROCESS_ID': '16',
            'APP_ID': "",//"HTL",
            'ORG_ID': "",//"HTL",
            'OS_VERSION': '9',
            'OUT_PROCESS_ID': 'get_channel_content',
            'LOGIN_ID': '',
            'PASSWORD': ''
          },
          'PWDATA': {

          },
          'PWERROR': ''
        }
      }
    }
  }

  getStaticRequestData() {
    return {
      'PWSESSIONRS': {
        'PWPROCESSRS': {
          'PWHEADER': {
            'IN_PROCESS_ID': '',
            'APP_ID': "HTA",
            'ORG_ID': "HTA",
            'OS_VERSION': '9',
            'OUT_PROCESS_ID': '',
            'LOGIN_ID': '',
            'PASSWORD': ''
          },
          'PWDATA': {

          },
          'PWERROR': ''
        }
      }
    }
  }



  sample_MB_Authentication_gmail() {
    return {
      'MB_Authentication_gmail': {
        'Row': [
          {

            'gmail_token': '',
            'user_id':''


          }
        ]
      }
    }
  }

  sample_user_logout() {
    return {
      "portal_logout": {
        "Row": [
          {
            "login_type": "",
            

          }
        ]
      }
    }
  }
  sample_get_preface() {
    return {
      'get_preface': {
        'Row': [
          {
            
                  
          }
        ]
      }
    }
  }
  sample_tnc_checkstatus() {
    return {
      'tnc_checkstatus': {
        'Row': [
          {

            'login_type': '',
            'device_id': '',
            'action': '',
            'token': ''
          }
        ]
      }
    }
  }
  sample_tnc_postdata() {
    return {
      'tnc_postdata': {
        'Row': [
          {

            'login_type': '',
            'device_id': '',
            'action': '',
            'token': ''
          }
        ]
      }
    }
  }
  
  sample_MB_REFRESH_TOKEN() {
    return {
      'MB_REFRESH_TOKEN': {
        'Row': [
          {
            'user_id':''


          }
        ]
      }
    }
  }

  sample_get_questions() {
    return {
      'get_questions': {
        'Row': [
          {
            'token':'',
            'user_id':''


          }
        ]
      }
    }
  }

  sample_portal_logout() {
    return {
      'portal_logout': {
        'Row': [
          {
          
            'user_id':''


          }
        ]
      }
    }
  }
  rfcRequest()
  {
    return {
      'RFCCALL': {
            'rfc_name':''  ,
            'import_table_name':'' ,
            'export_table_data':{},
            'params':{},
            'server':'' ,
            'app_name':'',
            'log_level':''
          } 
      
    }
  }
}